import React, { useState } from 'react';
import { View, Modal } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../../components/MyAppText';
import { WindowInformation } from '../../../services/window-information';
import { translate } from '../../../services/translate';
import CustomButton from '../../../components/CustomButton';
import FormInput from '../../../components/FormInput';


interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: (value: boolean) => void;
    onConfirm: () => Promise<void>;
    onReject: (message: string) => Promise<void>;
}
export default function ReviewModal({ isModalVisible, setModalVisible, onConfirm, onReject }: ModalProps) {
    const { styles } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    const [isRejecting, setIsRejecting] = useState(false);
    const [reason, setReason] = useState('');

    return (
        <Modal
            visible={isModalVisible}
            animationType='fade'
            onRequestClose={() => {
                setModalVisible(false);
            }}
            transparent={true}
        >
            <View style={styles.container}>
                <View style={styles.body(windowInfo.isMobile)}>
                    <MyAppText style={styles.header}>{translate('reviewMaintenanceRequest')}</MyAppText>
                    {!isRejecting ? <>
                        <View style={{ gap: 10 }}>
                            <MyAppText style={styles.subheader}>{translate('waitingForYourReviewText1')}</MyAppText>
                            <MyAppText style={styles.subheader}>{translate('waitingForYourReviewText2')}</MyAppText>
                            <View>
                                <View style={{ flexDirection: 'row', gap: 5 }}>
                                    <MyAppText style={[styles.subheader, styles.bold]}>{translate('confirm')}:</MyAppText>
                                    <MyAppText style={styles.subheader}>{translate('confirmMaintenanceRequest')}</MyAppText>
                                </View>
                                <View style={{ flexDirection: 'row', gap: 5 }}>
                                    <MyAppText style={[styles.subheader, styles.bold]}>{translate('reject')}:</MyAppText>
                                    <MyAppText style={styles.subheader}>{translate('rejectMaintenanceRequest')}</MyAppText>
                                </View>
                            </View>
                        </View>

                        <View style={styles.buttonsView}>
                            <CustomButton
                                onPress={() => setIsRejecting(true)}
                                text={translate('reject')}
                                type='secondary' />
                            <CustomButton
                                onPress={async () => await onConfirm()}
                                type='primary'
                                text={translate('confirm')} />
                        </View>
                    </> : <>
                        <View style={{ flex: 1 }}>
                            <MyAppText style={styles.subheader}>{translate('addReasonForRejection')}:</MyAppText>
                            <FormInput
                                labelFontSize={14}
                                placeholder={translate('reason')}
                                value={reason}
                                onChangeText={setReason}
                                invalid={(value: string) => {
                                    return value == '';
                                }}
                                multiline
                                numberOfLines={3}
                                maxLength={255}
                            />
                        </View>
                        <View style={styles.buttonsView}>
                            <CustomButton
                                onPress={() => setIsRejecting(false)}
                                text={translate('goBack')}
                                type='secondary' />
                            <CustomButton
                                onPress={async () => await onReject(reason)}
                                type='primary'
                                disabled={reason.trim() === ''}
                                text={translate('reject')} />
                        </View>
                    </>}
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1,
        paddingHorizontal: 16,
    },
    body: (isMobile: boolean) => ({
        width: isMobile ? '95%' : 635,
        height: isMobile ? '90%' : 291,
        backgroundColor: theme.colors.container.background,
        borderRadius: 4,
        paddingHorizontal: 16,
        paddingVertical: 24,
        rowGap: 32,
    }),
    header: {
        fontSize: 18,
        fontWeight: '700',
        flexWrap: 'wrap',
        color: theme.colors.modal.header,
    },
    subheader: {
        fontSize: 14,
        fontWeight: '400',
        flexWrap: 'wrap',
        color: theme.colors.modal.subheader,
    },
    bold: {
        fontWeight: 'bold',
    },
    buttonsView: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
}));
